import { Component, Input, OnInit } from '@angular/core';
import { FindControlIdService } from 'webcommon/legacy-common';
import { ApAlertService, ApBaseComponent, ApUndoableOperationService } from 'webcommon/core-ui';
import { FcListValidationService } from '../../generic/index';
import { FcNewModal, FcItemModalMode } from '../../../models/index';
import { ApFindControlService } from '../../ap-findcontrol.service';
import { FcItemModalService } from '../../fc-item-modal.service';
import { FindControlInitDto } from 'webcommon/shared';
import { Output, EventEmitter } from '@angular/core';

@Component({
    providers: [ApAlertService, FcListValidationService],
    selector: 'fc-new-item-button',
    styleUrls: ['./fc-new-item-button.component.less'],
    templateUrl: './fc-new-item-button.component.html',
})
export class FcNewItemButtonComponent extends ApBaseComponent implements OnInit {
    @Input() baseId: string;
    @Input() findControlId: string;
    @Input() buttonTitle: string;
    @Output() itemSaveSucceed = new EventEmitter<any>();

    public undoComponentId: number;
    public findControlInitDto: FindControlInitDto;

    constructor(
        private apFindControlService: ApFindControlService,
        public findControlIdService: FindControlIdService,
        protected apUndoableOperationService: ApUndoableOperationService,
        private fcItemModalService: FcItemModalService) {
        super();
    }

    public ngOnInit(): void {
        this.undoComponentId = this.apUndoableOperationService.registerComponent();
        this.apFindControlService
            .getConfig(this.findControlId)
            .pipe(
                this.takeUntilDestroy()
            )
            .subscribe(
                (data) => {
                    this.findControlInitDto = data;
                }
            );
    }
    public onNewClick(): any {
        this.apUndoableOperationService.queueOperation(this.undoComponentId, () => {
            const context: FcNewModal = {
                mode: FcItemModalMode.New,
                findControlId: this.findControlInitDto.FindControlBehavior.Id,
                findControlName: this.findControlInitDto.FindControlBehavior.Name,
                findControlConfig: this.findControlInitDto,
            };
            const promise = this.fcItemModalService.openModal(context).then(result => {
                if (result.isSuccess) {
                    this.itemSaveSucceed.emit(result);
                }
            });
            return {
                completionPromise: promise,
            };
        });
    }
}
